import {
    LIST_CENTERS,
    LIST_CENTERS_SUCCESS,
    LIST_CENTERS_ERROR
} from '../types';

import api from '../helpers/api';
import apiMethods from '../constants/apiMethods';
import messages from '../constants/messages';
// import authToken from '../config/token';

//LISTAR CATEGORIAS
export function listCentersAction() {
    return async (dispatch) => {
        //Inicializo
        dispatch( listCenters() );
        //Ejecuto la consulta
        try{
            //Hago la consulta
            const response = await api.get(apiMethods.CENTERS);
            //Obtengo los datos
            const res = response.data;
            //Llamo al dispatch
            dispatch( listCentersSuccess(res.data) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: messages.ERROR.SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listCentersError(data) );
        }
    }
}

const listCenters = () => ({
    type: LIST_CENTERS,
    payload: true
});

const listCentersSuccess = centers => ({
    type: LIST_CENTERS_SUCCESS,
    payload: centers
});

const listCentersError = error => ({
    type: LIST_CENTERS_ERROR,
    payload: error
});